import { render, staticRenderFns } from "./clazz-list.vue?vue&type=template&id=27d7419a&scoped=true&"
import script from "./clazz-list.vue?vue&type=script&lang=js&"
export * from "./clazz-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7419a",
  null
  
)

export default component.exports